import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import { createApiClient, createQueriesConfig, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra-react';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
// generateBusinessNames is a Metro API. Metro APIs cannot be used directly as a
// queryFn because createMetroApiConfig exposes them only through the react-query
// hook path (useQueries). The solution — established by WhoisApiClient — is to
// wrap the call inside a custom queryFn so createApiClient / createQueriesConfig
// manages the query lifecycle while the Metro API handles the HTTP call.
//
// generateBusinessNames is absent from the TypeScript type of
// DomainsApiClient.queries because the ambassador declarations are not available
// in the top-level node_modules. The method exists at runtime — the cast below
// is safe and consistent with how WhoisApiClient calls other Metro APIs.
const apiConfig = createQueriesConfig({
  generateBusinessNames: {
    queryFn: async _ref => {
      let httpClient = _ref.httpClient,
        request = _ref.request;
      const queries = DomainsApiClient.queries({
        httpClient
      });
      const res = await queries.generateBusinessNames(request);
      return {
        names: res.businessNames ?? []
      };
    },
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
  }
});
const _createApiClient = createApiClient(apiConfig),
  _Provider = _createApiClient.Provider,
  apiClient = _objectWithoutPropertiesLoose(_createApiClient, ["Provider"]);
export const BngApiClient = apiClient;
//# sourceMappingURL=businessNames.apiClient.js.map